import { useEffect, useRef, useState } from 'react';

// Deve casar com o zoom aplicado em .app-content (AppLayout.css)
const ZOOM_FACTOR = 0.78;

// Mede o espaço real disponível na tela (do topo do elemento até o fim da
// janela) e calcula a altura que o elemento precisa ter para preencher esse
// espaço, já compensando o zoom aplicado no layout. Evita depender de um
// "calc(100vh - Xpx)" fixo, que não acerta em telas diferentes.
export default function useInlineFillHeight(isOpen) {
  const ref = useRef(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    if (!isOpen) return;
    const el = ref.current;
    if (!el) return;
    const recalc = () => {
      const top = el.getBoundingClientRect().top;
      const available = (window.innerHeight - top - 12) / ZOOM_FACTOR;
      setHeight(Math.max(available, 400));
    };
    recalc();
    window.addEventListener('resize', recalc);
    return () => window.removeEventListener('resize', recalc);
  }, [isOpen]);

  return [ref, height];
}
